export default "/fr/_next/static/assets/images/sprite.57db2c9fedecff3c64c7795d854fa165.svg";